import { render, staticRenderFns } from "./HotelDescriptionFacilities.vue?vue&type=template&id=2dcc754c&"
import script from "./HotelDescriptionFacilities.vue?vue&type=script&setup=true&lang=ts&"
export * from "./HotelDescriptionFacilities.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./HotelDescriptionFacilities.vue?vue&type=style&index=0&id=2dcc754c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports